import { createContext, use } from 'react';

import type { CallDetailResponse } from '@/types/call.type';

interface CallContextType {
  call: CallDetailResponse | undefined;
}

const CallContext = createContext<CallContextType | undefined>(undefined);

export function CallDetailProvider({
  children,
  data,
}: {
  children: React.ReactNode;
  data: CallDetailResponse | undefined;
}) {
  return <CallContext value={{ call: data }}>{children}</CallContext>;
}

export function useCallDetail() {
  const context = use(CallContext);
  if (!context) throw new Error('useCallDetail must be used within CallDetailProvider');
  return context;
}
